import React from "react";
import "../App.css";

// Import your images
import carpenterImg from "../images/worker1.jpg";
import tileWorksImg from "../images/worker2.jpg";
import cleaningImg from "../images/worker3.jpg";
import plumbingImg from "../images/worker4.jpg";

export default function ServiceDetails() {
  const services = [
    {
      title: "Carpenter",
      description:
        "Our professional carpenters handle furniture repair, custom woodwork, and home fittings efficiently.",
      image: carpenterImg,
    },
    {
      title: "Tile Works",
      description:
        "Expert tiling services for floors, walls, and bathrooms with quality finishes.",
      image: tileWorksImg,
    },
    {
      title: "Cleaning",
      description:
        "Home and office cleaning services including deep cleaning and sanitization.",
      image: cleaningImg,
    },
    {
      title: "Plumbing",
      description:
        "Reliable plumbing services including repairs, installations, and maintenance.",
      image: plumbingImg,
    },
  ];

  return (
    <div className="container py-5">
      <h2 className="text-center mb-5">Our Services Details</h2>
      {services.map((service, index) => (
        <div className="row mb-5 align-items-center" key={index}>
          <div className="col-md-6">
            <img
              src={service.image}
              alt={service.title}
              className="img-fluid rounded shadow"
            />
          </div>
          <div className="col-md-6">
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        </div>
      ))}
      {/* Cleaning Animations Section */}
<div className="cleaning-wrapper mt-3">

  {/* 1) Wipe Shine Animation */}
  <div className="clean-wipe mb-3">
    Cleaning in Progress...
  </div>

  {/* 2) Broom Sweeping Animation */}
  <div className="broom-area mb-3">
    🧹
  </div>

  {/* 3) Floating Cleaning Bubbles */}
  <div className="bubble-clean mb-3">
    <div className="bubble"></div>
    <div className="bubble"></div>
    <div className="bubble"></div>
  </div>

  {/* 4) Mop Cleaning Loader */}
  <div className="clean-loader mb-3">
    <span className="mop">🧽</span>
    <p>Cleaning...</p>
  </div>

</div>

    </div>
    
  );
}
